import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";

import { ApiService } from "src/app/shared/services/api.service";
import { IndustryTypeService } from "src/app/shared/services/industry-type-services/industry-type.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";
import { UserService } from "src/app/shared/services/user-services/user.service";
import { environment } from "src/environments/environment";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-multi-organization',

  templateUrl: './multi-organization.component.html',
  styleUrl: './multi-organization.component.css'
})
export class MultiOrganizationComponent {
  userAForm!: FormGroup;
  userBForm!: FormGroup;
  userCForm!: FormGroup;
  userDForm!: FormGroup;
  userEForm!: FormGroup;
  empForm!: FormGroup;
  materialsForm!: FormGroup; 
  organizationId: any;

  add = false
  states: any;
  cities: any;
  stateFilter = ''; // used for the search input
  roles: any
  roleName: any;
  // Store available states and cities for each branch index
  availableStates: any[] = [];
  availableCities: any[] = [];
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  imageBaseUrl = environment.imageBaseUrl;
  domanArray: any;
  profileForm!: FormGroup;
  jobRoles = ['Developer', 'Manager', 'HR', 'Accountant']; // example roles
  accessTypes = ['Internal', 'External', 'Admin'];
  org_emp = false;
  org_emp_imp = false;
  rowData: any[] = [];
  columnDefs: any[] = [];

  defaultColDef = { editable: true, resizable: true, sortable: true, filter: true };
  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService,
    private sanitizer: DomSanitizer, private dialog: MatDialog
  ) {



  }


  ngOnInit() {
    const user = localStorage.getItem('user') as any;
    const userParse = JSON.parse(user);
    this.roleName = userParse.user.role_name;
    this.route.params.subscribe((params) => {
      this.organizationId = params['id'];
    });
    if (this.organizationId) {
      this.getOrganizationDetails();
    }
    this.getRole()
    this.userAForm = this.formBuilder.group({
      org_name: ["", Validators.required],
      org_type: ["", Validators.required],
      registration_number: [""],
      gst_number: ["", [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      pan_number: ["", [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      city: ["", Validators.required],
      state: ["", Validators.required],
      postal_code: ["", Validators.required],
      country: ["", Validators.required],
      domain: ["", Validators.required],
      org_logo: [null],
      address: ["", Validators.required],

    });
    this.userBForm = this.formBuilder.group({
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
    this.userCForm = this.formBuilder.group({
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
    this.userCForm = this.formBuilder.group({
      contacts: this.formBuilder.array([this.createContactGroup()])
    });
    this.userDForm = this.formBuilder.group({
      onboarding_date: ["", Validators.required],
      status: [true],
      membership_start_date: ["", Validators.required],
      membership_end_date: ["", Validators.required],
    })
    this.userEForm = this.formBuilder.group({
      additionalBranch: this.formBuilder.array([this.createBranchGroup()])
    });
    this.materialsForm = this.formBuilder.group({
      companyName: [''],
      companyCode: [''],
      branchName: [''],
      branchCode: [''],

      materialName: ['', Validators.required],
      category: ['', Validators.required],
      subcategory: [''],
      manufacturer: [''],
      code: [''],
      region: [''],

      strength: [''],
      density: [''],
      size: [''],
      length: [null],
      width: [null],
      thickness: [null],
      unit: [''],

      quantity: [null],
      unitCost: [null],
      totalCost: [null],

      name: [''],
      location: [''],
      leadTime: [null],
      carbonFootprint: [null],
      recyclability: [null],

      buildingType: [''],
      useCase: [''],
      certifications: [''],
      testingMethod: [''],
      tools: [''],
      method: [''],

      countries: [''],
      regions: [''],

      durability: [''],
      fireResistance: [''],
      brand: [''],
      model: ['']
    });
    this.availableStates[0] = [];
    this.availableCities[0] = [];



  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadImage(this.selectedFile)
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.selectedFile);

    }
  }

  uploadImage(file: any) {
    // const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.apiService.uploadContractDocs(file, 'org')?.subscribe({
        next: (res: any) => {
          console.log(res?.org)
          this.userAForm.patchValue({
            org_logo: res?.org,
          });
          console.log(this.userAForm.value.org_logo)

          this.userAForm.get('org_logo')?.updateValueAndValidity();
          this.toastrMsgService.success('Organization logo uploaded successfully');
        },
        error: err => console.error('Organization logo upload failed', err)
      });
    }
  }

  // Getter for easy access
  get contacts() {
    return this.userCForm.get('contacts') as FormArray;
  }



  // Create one contact group
  createContactGroup(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      role: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      userType: ['', Validators.required]
    });
  }

  // Add new contact
  addContact() {
    this.contacts.push(this.createContactGroup());
  }

  // Remove contact at index
  removeContact(index: number) {
    if (this.contacts.length > 1) {
      this.contacts.removeAt(index);
    }
  }

  // Getter for easy access
  get additionalBranch() {
    return this.userEForm.get('additionalBranch') as FormArray;
  }



  // Create one contact group
  createBranchGroup(): FormGroup {
    return this.formBuilder.group({
      branch_id: [''],
      org_id: [this.organizationId, Validators.required],
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      country: ['', Validators.required],
      postal_code: ['', Validators.required],
      branch_name: ['', Validators.required],
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
  }

  // Add new contact
  addBranch() {
    this.additionalBranch.push(this.createBranchGroup());
    // Also prepare arrays for new index
    const index = this.additionalBranch.length - 1;
    this.availableStates[index] = [];
    this.availableCities[index] = [];
  }

  // Remove contact at index
  removeBranch(index: number) {
    if (this.additionalBranch.length > 1) {
      this.additionalBranch.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableCities.splice(index, 1);
  }


  onSubmit(): void {
    if (this.organizationId) {
      this.update(this.organizationId);
    } else {
      console.log(this.userAForm.value.domain)
      const types = this.userAForm.value.domain
      const result = types.join(', ');
      console.log(result);
      var addUser = {
        "org_name": this.userAForm.value.org_name,
        "org_type": this.userAForm.value.org_type,
        "registration_number": this.userAForm.value.registration_number,
        "gst_number": this.userAForm.value.gst_number,
        "city": this.userAForm.value.city,
        "state": this.userAForm.value.state,
        "postal_code": this.userAForm.value.postal_code,
        "pan_number": this.userAForm.value.pan_number,
        "country": this.userAForm.value.country,
        "domain": result,
        "primary_contact_name": this.userBForm.value.primary_contact_name,
        "primary_contact_phone": this.userBForm.value.primary_contact_phone,
        "primary_contact_email": this.userBForm.value.primary_contact_email,
        "users": this.userCForm.value.contacts,
        "branches": this.userEForm.value.additionalBranch,
        "onboarding_date": this.userDForm.value.onboarding_date,
        "status": this.userDForm.value.status,
        "membership_start_date": this.userDForm.value.membership_start_date,
        "membership_end_date": this.userDForm.value.membership_end_date,
        "org_logo": this.userAForm.value.org_logo,

      }
      this.apiService.saveOrganization(addUser).subscribe({
        next: (res) => {
          this.toastrMsgService.success('Organization added successfully');
          this.router.navigate(['home/company']);

        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => console.log("Observable complete"),
      });
    }
  }
  update(id: any): void {
    console.log(this.userAForm.value.domain)
    const types = this.userAForm.value.domain
    const result = types.join(', ');
    console.log(result);
    var addUser = {
      "org_name": this.userAForm.value.org_name,
      "org_type": this.userAForm.value.org_type,
      "registration_number": this.userAForm.value.registration_number,
      "gst_number": this.userAForm.value.gst_number,
      "city": this.userAForm.value.city,
      "state": this.userAForm.value.state,
      "postal_code": this.userAForm.value.postal_code,
      "pan_number": this.userAForm.value.pan_number,
      "country": this.userAForm.value.country,
      "domain": result,
      "primary_contact_name": this.userBForm.value.primary_contact_name,
      "primary_contact_phone": this.userBForm.value.primary_contact_phone,
      "primary_contact_email": this.userBForm.value.primary_contact_email,
      "users": this.userCForm.value.contacts,
      "onboarding_date": this.userDForm.value.onboarding_date,
      "status": this.userDForm.value.status,
      "membership_start_date": this.userDForm.value.membership_start_date,
      "membership_end_date": this.userDForm.value.membership_end_date,
      "org_logo": this.userAForm.value.org_logo,
      "branches": this.userEForm.value.additionalBranch,



    }

    this.apiService.updateOrganization(id, addUser).subscribe({
      next: (res) => {
        this.toastrMsgService.success('Organization Updated successfully');
        this.router.navigate(['home/company']);
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });

  }

  getOrganizationDetails() {
    this.apiService.getOrganizations({} as any).subscribe({
      next: (res: any) => {
        console.log(res);
        const data = res.data.find((project: any) => project.org_id == this.organizationId);

        const lData = data?.branches || [];
        const branchFormArray = this.additionalBranch;
        branchFormArray.clear();
        lData.forEach((loc: { country: any; state: any; city: any; lat: any; long: any; postal_code: any; branch_name: any; primary_contact_name: any; primary_contact_email: any; primary_contact_phone: any; branch_id: any }, index: number) => {
          const branchGroup = this.createBranchGroup();
          this.additionalBranch.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              postal_code: loc.postal_code || '',
              branch_name: loc.branch_name || '',
              primary_contact_name: loc.primary_contact_name || '',
              primary_contact_email: loc.primary_contact_email || '',
              primary_contact_phone: loc.primary_contact_phone || '',
              branch_id: loc.branch_id || ''
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createBranchGroup());
        }



        const uData = data?.people || [];

        // De-duplicate
        const uniquePeopleMap = new Map();
        uData.forEach((person: { email: any; contact_email: any; id: any; }) => {
          const key = person.email || person.contact_email || person.id;
          if (!uniquePeopleMap.has(key)) {
            uniquePeopleMap.set(key, person);
          }
        });
        const uniquePeople = Array.from(uniquePeopleMap.values());

        const contactsFormArray = this.contacts;
        contactsFormArray.clear();

        uniquePeople.forEach(person => {
          contactsFormArray.push(this.formBuilder.group({
            name: [person?.full_name || '', Validators.required],
            email: [person?.email || person?.contact_email || '', [Validators.required, Validators.email]],
            mobile: [person?.primary_phone || person?.phone || '', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
            userType: [person?.user_type || '', Validators.required],
            role: [person?.role_id || '', Validators.required],
            // role field skipped
          }));
        });

        if (contactsFormArray.length === 0) {
          contactsFormArray.push(this.createContactGroup());
        }

        // this.orgForm.patchValue(data);
        if (typeof data.domain === 'string') {
          this.domanArray = data.domain.split(',').map((s: string) => s.trim());
          console.log(this.domanArray);

        } else {
          console.error('data is not a string:', data.domain);
        }
        this.userAForm.patchValue({
          org_name: data.org_name,
          org_type: data.org_type,
          registration_number: data.registration_number,
          gst_number: data.gst_number,
          pan_number: data.pan_number,
          country: data.country,
          city: data.city,
          state: data.state,
          postal_code: data.postal_code,
          domain: this.domanArray,
          org_logo: data.org_logo,
          uniquecode: data.uniquecode,

        })
        console.log(this.userAForm.value)
        this.imagePreview = this.imageBaseUrl + data.org_logo
        console.log(this.imagePreview)
        this.userBForm.patchValue({
          primary_contact_name: data.primary_contact_name,
          primary_contact_email: data.primary_contact_email,
          primary_contact_phone: data.primary_contact_phone,
        })
        this.userDForm.patchValue({
          onboarding_date: data.onboarding_date,
          membership_start_date: data.membership_start_date,
          membership_end_date: data.membership_end_date,
          status: data.status,
        })

        this.onCountryChange();
        this.onStateChange();

      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }
  
  onCountryChange() {
    const country = this.userAForm.value.country;
    console.log(country)
    this.apiService.getstates().subscribe({
      next: (res) => {
        console.log(res);
        this.states = res
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });

    // this.cities = [];
    if (this.organizationId) {
      this.userAForm.patchValue({ state: this.userAForm.value.state, city: this.userAForm.value.city });

    } else {
      this.userAForm.patchValue({ state: '', city: '' });

    }

  }


  onStateChange() {
    const state = this.userAForm.value.state;
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        console.log(res);
        this.cities = res;
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });
    if (this.organizationId) {
      this.userAForm.patchValue({ city: this.userAForm.value.city });

    } else {
      this.userAForm.patchValue({ city: '' });

    }
  }


  getRole() {
    this.apiService.getAllRoles().subscribe({
      next: (res: any) => {
        console.log('Roles fetched successfully:', res);
        // Ensure res is an array before assigning to dataSource
        this.roles = res;
      },
      error: (err) => {
        console.error('Error occurred:', err);
      },
      complete: () => {
        console.log('Role fetch observable completed');
      }
    });
  }

  onCountryBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedCountry = branch.get('country')?.value;
    this.apiService.getstates().subscribe({
      next: (res) => {
        console.log(res);
        this.availableStates[index] = res ? res : []
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });


    // Reset dependent controls
    branch.patchValue({ state: '', city: '' });
  }

  onStateBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedCountry = branch.get('country')?.value;
    const selectedState = branch.get('state')?.value;
    this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        console.log(res);
        this.availableCities[index] = res ? res : [];
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log("Observable complete"),
    });


    // Reset city control
    branch.patchValue({ city: '' });
  }

  openPicker(index: number, branch: any) {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Selected Coordinates:', result);
        branch.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }



  addEmp() {
    this.org_emp = true
    this.empForm = this.formBuilder.group({
      companyName: ['', Validators.required],
      companyId: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],
      branchName: ['', Validators.required],
      branchId: ['', Validators.required],

      employeeCode: [{ value: 'BADGE-1234', disabled: true }, [Validators.required]],
      employeeId: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]+$/)]],

      fullName: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.pattern(/^\+\d{1,4}-\d{3}-\d{3}-\d{4}$/)]],

      jobRole: ['', Validators.required],
      designation: ['', [Validators.pattern(/^[a-zA-Z0-9-]+$/)]],

      hireDate: ['', Validators.required],
      endDate: [''],
      safetyTraining: [false],
      pincode: ['', [Validators.pattern(/^\d{6}$/)]],
      emergencyContact: ['', [Validators.maxLength(100)]],
      role: ['', Validators.required],

      subscriptionStart: ['', Validators.required],
      subscriptionEnd: [''],
    });
  }

  addEmpImp() {
    this.org_emp_imp = true
  }


  onFileChange(event: any) {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onload = (e: any) => {
      const bstr = e.target.result;
      const workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      this.rowData = this.processDateColumns(jsonData);
      this.columnDefs = this.generateColumnDefs(jsonData);
    };

    reader.readAsBinaryString(file);
  }
  processDateColumns(data: any[]): any[] {
    return data.map(row => {
      const newRow: any = { ...row };
      for (const key in row) {
        if (this.isDateString(row[key])) {
          newRow[key] = new Date(row[key]);
        }
      }
      return newRow;
    });
  }

  isDateString(value: any): boolean {
    // Detect ISO or slash-based dates (basic)
    return typeof value === 'string' &&
      (/\d{4}-\d{2}-\d{2}/.test(value) || /\d{2}\/\d{2}\/\d{4}/.test(value));
  }
  generateColumnDefs(data: any[]): any[] {
    if (!data || data.length === 0) return [];

    const firstRow = data[0];
    return Object.keys(firstRow).map(key => {
      const isDateCol = data.some(row => row[key] instanceof Date);

      return {
        headerName: key,
        field: key,
        filter: isDateCol ? 'agDateColumnFilter' : true,
        valueFormatter: isDateCol
          ? (params: any) => this.dateFormatter(params.value)
          : undefined,
      };
    });
  }

  dateFormatter(value: any): string {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleDateString('en-GB'); // or use DatePipe
  }


  saveChanges() {
    console.log('Updated Data:', this.rowData);
    // You can send `this.rowData` to the backend
    const params = { type: 'staff', file: this.rowData };

    this.apiService.addImport(params).subscribe({
      next: (res) => {
        this.toastrMsgService.success('Import Updated successfully');

      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

}
